import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = window.location.hash || "";
        const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
        (async () => {
            if (!sessionId) {
                navigate("/login", { replace: true });
                return;
            }
            try {
                const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
                setUser(data.user);
                window.history.replaceState(null, "", window.location.pathname);
                navigate(data.user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
            } catch {
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen grid place-items-center bg-white">
            <div className="h-8 w-8 rounded-full border-2 border-neutral-200 border-t-ink animate-spin" />
        </div>
    );
}
